<div class="modal-header">
  {{verb}}
  <i class="material-icons" #closebtn data-bs-dismiss="modal" (click)='closeModal()'>close</i>
</div>
<form #categoryForm="ngForm">
  <div class="modal-body">
    <div class="form-group">
      <div class="row align-items-center">
        <label class="col-sm-4 control-label">Name</label>
        <div class="col-sm-8">
          <input name="categoryName" [(ngModel)]="selectedCategory.name" ngControl="selectedCategory.name"
            type="text" class="form-control vplaybook__form__inputs" required>
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="row">
        <label class="col-sm-4 control-label pt-0">Cover</label>
        <div class="col-sm-8">
          <div class="upload-image">
            <div class="upload-image-file">
              @if (uploadedImg || selectedCategory?.iconAssetId) {
                <a class="remove-placeholder-image"
                  (click)="removeImage()">
                  <i class="material-icons" style="color: #8d8d8d">delete</i>
                </a>
              }
              @if (!(uploadedImg || selectedCategory?.iconAssetId )) {
                <div
                  (click)="openFileDialog()" class="upload-box pointer" title="click to change file">
                  <span class="material-icons upload-icon upload-icon-color">cloud_upload</span>
                </div>
              } @else {
                <img id="imgBackground" title="click to change file" (click)="openFileDialog()" class="upload-box pointer"
                  [src]="getImageSrc() | loadSecureAssets  : true | async" alt="" onerror="this.src = 'assets/img/loader.gif'"
                  (load)="imageLoaded = true;" [hidden]="!imageLoaded" />
              }
              <div class="file-upload hide" style="display: none;">
                <label for="uploadPreviewImage" class="file-upload__label">Upload Preview Image</label>
                <input id="uploadPreviewImage" #fileInput (click)="fileInput.value = null"
                  (change)="imageSelected($event)" accept="image/jpg, image/jpeg, image/png"
                  class="file-upload__input" type="file" name="preview-file-upload">
              </div>
              <div id="transparent-uploadifive-queue"></div>
            </div>
            <span class="text-center">Upload JPEG or PNG</span>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="row align-items-center">
        <label class="col-sm-4 control-label">Company</label>
        <div class="col-sm-8">
          <select class="form-control vplaybook__form__inputs" [(ngModel)]="selectedCategory.companyId"
            name="companyId">
            <option [ngValue]="0">None</option>
            @for (company of companyList; track company) {
              <option [ngValue]="company.id">{{company.name}}</option>
            }
          </select>
        </div>
      </div>
    </div>
  </div>
</form>
<div class="modal-footer">
  @if (selectedCategory?.id) {
    <button type="button" class="btn vPlaybookDefaultButton btn__btn-default"
    (click)="deleteCategory()">Delete</button>
  }
  <button type="button" class="btn vPlaybookDefaultButton btn__btn-default" data-bs-dismiss="modal"
  (click)='closeModal()'>Cancel</button>
  <button type="submit" class="btn btn__btn-default btn__orange" (click)="saveCategory(verb)"
  [ngClass]="{'custom-btn-disabled': categoryForm.invalid}" [disabled]="categoryForm.invalid">Save</button>
</div>